<template>
    <div>
        <div class='footer-column-title'>
            ABOUT US
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('wine-club/about')"><a class="footer-link">About Us</a></div>
            <div @click="onClickLink('wine-club/contact-us')"><a class="footer-link">Contact Us</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            if(page == 'itim') {
                window.open('https://www.itim.com', '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>